import React, { useEffect, useState } from "react";
import PageHeading from "../../CustomComponents/PageHeading";
import * as constants from "../../../constants";
import { IonButton, IonCol, IonIcon, IonLabel, IonToast } from "@ionic/react";
import { connect } from "react-redux";
import { documentTemplate } from "../../../Store/Actions";
import { chevronForwardOutline } from "ionicons/icons";
import { ToastMessage } from "../../../utils/toastMessage";

const DocumentVault: React.FC = (props: any) => {
  React.useEffect(() => {
    getDocumentTemplate();
  }, []);
  const getDocumentTemplate = async () => {
    await props.documentTemplate();
  };

  const [state, setState] = useState<any>({
    userRCData: {},
    userInsuranceData: {},
    userPUCCData: {},
    documents: [],
    updatedList: [],
  });
  const [toast, setToast] = useState({
    showToast: false,
    toastMessage: "",
    severity: "",
  });
  React.useEffect(() => {
    async function getDocuments() {
      if (!!props.match.params.id) {
        const vehicle =
          props.userVehiclesList.length &&
          props.userVehiclesList.find((ele: any) => ele.did === props.match.params.id);
        const documents =
          !!vehicle &&
          vehicle.documentIds.length &&
          (await getVehiclesDocumentData(vehicle.documentIds));
        if (documents.length) {
          await setState({
            ...state,
            documents,
          });
        }
      }
      if ((props.userVehiclesList || []).length) {
        if (!!props.location.state && props.location.state.fromDocumentVault) {
          const defaultVehicle =
            !!props.selectedVehicleRef &&
            props.userVehiclesList.find(
              (ele: any) => ele.did === props.selectedVehicleRef.split("/").pop(),
            );
          const documents =
            !!defaultVehicle &&
            defaultVehicle.documentIds.length &&
            (await getVehiclesDocumentData(defaultVehicle.documentIds));

          if (documents.length) {
            await setState({
              ...state,
              documents,
            });
          }
        }
      }
    }
    getDocuments();
    return () => {
      setState({
        userRCData: {},
        userInsuranceData: {},
        userPUCCData: {},
        documents: [],
      });
    };
  }, [props.userVehiclesList, props.userDocumentsList, props.selectedVehicleRef]);

  const getVehiclesDocumentData = (data: any) => {
    const vehiclesDocData = data.reduce((acc: Array<any>, vehicle: any) => {
      acc.push(
        (props.userDocumentsList || []).find(
          (ele: any) => ele.did === (vehicle || "").split("/").pop(),
        ),
      );
      return acc;
    }, []);
    return vehiclesDocData;
  };

  const updatedData = () => {
    const a = (props.documentTemplateList || []).map((ele: any) => {
      const b =
        state.documents.length &&
        state.documents.find((element: any) => element.documentType === ele.name);
      if (Object.keys(b || {}).length) {
        return { ...ele, ...b };
      }
      return ele;
    });
    const d = a.map((ele: any) => {
      if (ele.supportsId === "true") {
        const objIndex = ele.additionalFieldsToCapture.findIndex(
          (item: any) => item.fieldName == "documentId",
        );
        if (objIndex < 0) {
          ele.additionalFieldsToCapture = [
            {
              fieldDisplayName: ele.idFieldDisplayName,
              fieldName: "documentId",
              value: !!ele.documentId ? ele.documentId : "",
            },
            ...ele.additionalFieldsToCapture,
          ];
        } else {
          ele.additionalFieldsToCapture[objIndex].value = ele.documentId || "";
        }
      }
      ele.additionalFieldsToCapture = ele.additionalFieldsToCapture.map((field: any) => {
        if (field.fieldName === "documentId") {
          return {
            ...field,
          };
        } else {
          return {
            ...field,
            value: !!ele.additionalFields ? ele.additionalFields[field.fieldName] : "",
          };
        }
      });
      if (ele.supportsExpiration === "true") {
        const objIndex = ele.additionalFieldsToCapture.findIndex(
          (item: any) => item.fieldName == "expirationDate",
        );

        if (objIndex < 0) {
          ele.additionalFieldsToCapture = [
            ...ele.additionalFieldsToCapture,
            {
              fieldDisplayName: "Expiration Date",
              fieldName: "expirationDate",
              value: !!ele.expirationDate ? new Date(ele.expirationDate) : "",
            },
          ];
        } else {
          ele.additionalFieldsToCapture[objIndex].value = !!ele.expirationDate
            ? new Date(ele.expirationDate)
            : "";
        }
      }
      return ele;
    });
    return d;
  };

  return (
    <IonCol className="middle_panle res_bg_color" size-md="6">
      <div className="doc_vault_header">
        <PageHeading
          mainHeader="Document Vault"
          navigation={props}
          //cssClass="background-for-non-forms-screens"
        />
      </div>
      <div className="document-main-div">
        {Boolean(props.documentTemplateList.length) &&
          updatedData().map((ele: any, index: any) => (
            <div className={index > 0 ? "document-types margin20" : "document-types"} key={index}>
              <div className="document-type-div">
                <IonLabel color="secondary" className="document-type-label">
                  {ele.displayTitle}
                </IonLabel>
                <IonButton
                  color="primary"
                  className="upload-button"
                  onClick={() =>
                    props.userVehiclesList.length && !!props.selectedVehicleRef
                      ? props.history.push({
                          pathname: "/portal/add-RC",
                          state: {
                            vehicleId: !!props.match.params.id
                              ? props.match.params.id
                              : props.selectedVehicleRef.split("/").pop(),
                            userRcData: ele.additionalFieldsToCapture,
                            documentTemplate: ele,
                          },
                        })
                      : !!!props.selectedVehicleRef ||
                        !Object.keys(
                          (props.userVehiclesList || []).find(
                            (ele: any) =>
                              ele.did === (props.selectedVehicleRef || "").split("/").pop(),
                          ) || {},
                        ).length
                      ? setToast({
                          toastMessage: "Please select a vehicle before uploading",
                          showToast: true,
                          severity: "warning",
                        })
                      : setToast({
                          toastMessage: "Please add vehicle before uploading",
                          showToast: true,
                          severity: "warning",
                        })
                  }
                >
                  {constants.UPLOAD}
                </IonButton>
                <IonIcon
                  icon={chevronForwardOutline}
                  className="mobile-icon"
                  onClick={() =>
                    props.userVehiclesList.length
                      ? props.history.push({
                          pathname: "/portal/add-RC",
                          state: {
                            vehicleId: !!props.match.params.id
                              ? props.match.params.id
                              : props.selectedVehicleRef.split("/").pop(),
                            userRcData: ele.additionalFieldsToCapture,
                            documentTemplate: ele,
                          },
                        })
                      : setToast({
                          toastMessage: "Please add vechicle before uploading",
                          showToast: true,
                          severity: "warning",
                        })
                  }
                ></IonIcon>
              </div>
              <div className="document-details">
                <div className="document-contents">
                  {ele.additionalFieldsToCapture.map((field: any, index: any) => (
                    <div style={{ width: "50%" }} key={index}>
                      <IonLabel
                        color="secondary"
                        className="label"
                        style={{
                          marginTop: index > 1 ? "10px" : 0,
                        }}
                      >
                        {field.fieldDisplayName}
                      </IonLabel>
                      <IonLabel color="tertiary" className="value-label">
                        {!!field.value && field.fieldDisplayName === "Expiration Date"
                          ? field.value.toLocaleDateString()
                          : !!field.value && field.fieldDisplayName !== "Expiration Date"
                          ? field.value
                          : "-----"}
                      </IonLabel>
                    </div>
                  ))}
                </div>
              </div>
              {props.documentTemplateList.length - 1 !== index && (
                <div className="bottom-border"></div>
              )}
            </div>
          ))}
        <ToastMessage
          showToast={toast.showToast}
          ToastMessage={toast.toastMessage}
          severity={toast.severity}
          onDidDismiss={() => {
            setToast({
              showToast: false,
              toastMessage: "",
              severity: "",
            });
          }}
        />
      </div>
    </IonCol>
  );
};

export default connect(
  ({
    auth,
    userInfo: { userDocumentsList, userVehiclesList },
    addVehicles: { documentTemplateList },
  }: any) => ({
    ...auth,
    userDocumentsList,
    userVehiclesList,
    documentTemplateList,
  }),
  { documentTemplate },
)(DocumentVault);
